import { createSlice } from "@reduxjs/toolkit";
import { EventItem } from "interface/interface";

export interface WebhookInitialStateInterface {
	loading: boolean;
	webhooks: Record<string, any>[];
	error: boolean;
	events: EventItem[];
	registerLoading: boolean;
	webhook: Record<string, any> | null;
}
const InitialState: WebhookInitialStateInterface = {
	loading: false,
	webhooks: [],
	error: false,
	events: [],
	registerLoading: false,
	webhook: null,
};

const webhookOnSlice = createSlice({
	name: "webhook",
	initialState: InitialState,
	reducers: {
		setLoading: (state, { payload }) => {
			state.loading = payload;
		},
		setRegisterLoading: (state, { payload }) => {
			state.registerLoading = payload;
		},
		setWebhooks: (state, { payload }) => {
			state.webhooks = payload;
		},
		setWebhook: (state, { payload }) => {
			state.webhook = payload;
		},
		setError: (state, { payload }) => {
			state.error = payload;
		},
		setEvents: (state, { payload }) => {
			state.events = payload;
		},
	},
});

export const { setLoading, setWebhooks, setError, setEvents,setRegisterLoading,setWebhook } = webhookOnSlice.actions;
export default webhookOnSlice.reducer;
